<template>
    <div class="customerListWrap">
        <!-- 第一块 -->
        <div class="fengexian">基础信息</div>
        <div class="panelBlock">
            <div class="panelContent erweimaRow">
                <div class="left">
                    <el-row>
                        <el-col :span="6">
                            <div class="itemBox">
                                <span class="label">姓名：</span>
                                <span>{{infoObj.user_realname}}</span>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="itemBox">
                                <span class="label">参赛编号：</span>
                                <span>{{infoObj.user_serial_number}}</span>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="itemBox">
                                <span class="label">参赛组别：</span>
                                <span >{{infoObj.teamId}}组</span>
                            </div>
                        </el-col>

                        <el-col :span="6">
                            <div class="itemBox">
                                <span class="label">手机号：</span>
                                <span>{{infoObj.phone}}</span>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="itemBox">
                                <span class="label">年龄：</span>
                                <span>{{infoObj.age}}
                                    <span v-if="infoObj.age">岁</span>
                                </span>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="itemBox">
                                <span class="label">身份证号：</span>
                                <span>{{infoObj.user_id_number}}</span>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="itemBox">
                                <span class="label">擅长品类：</span>
                                <span>{{infoObj.goodAtCategory}}</span>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="itemBox">
                                <span class="label">从业时间：</span>
                                <span>{{infoObj.yearsOfWork}}
                                    <span v-if="infoObj.yearsOfWork">年</span>
                                </span>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="itemBox">
                                <span class="label">年收入：</span>
                                <span>{{infoObj.yearOfIncome}}
                                    <span v-if="infoObj.yearOfIncome">万元</span>
                                
                                </span>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="itemBox">
                                <span class="label">婚姻状况：</span>
                                <span>{{infoObj.marryStatus}}</span>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="itemBox">
                                <span class="label">子女数量：</span>
                                <span>{{infoObj.numberOfChildren}}
                                    <span v-if="infoObj.numberOfChildren">个</span>
                                </span>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="itemBox">
                                <span class="label">籍贯：</span>
                                <span>{{infoObj.nativePlace}}</span>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="itemBox">
                                <span class="label">现居住地址：</span>
                                <span>{{infoObj.address}}</span>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="itemBox">
                                <span class="label">杭州居住时间：</span>
                                <span>{{infoObj.residenceTimeInHangzhou}}
                                    <span v-if="infoObj.residenceTimeInHangzhou">年</span>
                                </span>
                            </div>
                        </el-col>

                    </el-row>
                </div>
                <div class="right">
                    <!-- <canvas id="canvas"></canvas> -->
                </div>


            </div>
        </div>
        <div class="fengexian">
            预赛成绩
            <div class="totalBox">
                <div class="line">
                    个人总成绩 
                    <span class="score">{{gradesObj_prev.playerTotalScore}}</span>分,
                    第<span class="score">{{gradesObj_prev.playerTotalRanking |getInt}}</span>名
            
                </div>
                <div class="line">
                    团队总成绩 
                    <span class="score">{{gradesObj_prev.teamTotalScore}}</span>分,
                    第<span class="score">{{gradesObj_prev.teamTotalRanking |getInt}}</span>名
                
                </div>
                
                <div class="line">
                    是否进入决赛：
                    <span class="score">{{gradesObj_prev.isAdvance}}</span>
                </div>
            </div>
        </div>
        <!-- 第二块 -->
        <div class="bigBlockWrap">
            <div class="panelBlock">
                <div class="panelTitle">
                    成品展示 (占比15%)
                    
                
                </div>
                <div class="panelContent">
                    <el-row>
                        <el-col :span="6">
                            <span>评委一 </span>
                            <span class="score">{{gradesObj_prev.model1judge1Fraction}}</span>
                            <span>分</span>
                        </el-col>
                        <el-col :span="6">
                            <span>评委二</span>
                            <span class="score">{{gradesObj_prev.model1judge2Fraction}}</span>
                            <span>分</span>
                        </el-col>
                        <el-col :span="6">
                            <span>评委三</span>
                            <span class="score">{{gradesObj_prev.model1judge3Fraction}}</span>
                            <span>分</span>
                        </el-col>
            
                    </el-row>
                    <div class="titleRightSection">
                        <span class="">考核内容模块一综合得分</span>
                        <span class="score">{{gradesObj_prev.model1totalscore}}</span>
                        <span>分</span>
                    </div>
            
                </div>
            </div>
            <div class="panelBlock">
                <div class="panelTitle">工艺解读(占比60%)
                    
                </div>
                <div class="panelContent">
                    <el-row>
                        <el-col :span="6">
                            <span>样衣编号</span>
                            <span class="score">{{gradesObj_prev.model2SampleClothingNumber}}</span>
                        </el-col>
                        <el-col :span="6">
                            <span>获得分数</span>
                            <span class="score">{{gradesObj_prev.model2paperscore}}</span>
                            <span>分</span>
                        </el-col>
            
                    </el-row>
                    <div class="titleRightSection">
                        <span class="">考核内容模块二综合得分</span>
                        <span class="score">{{gradesObj_prev.model2totalscore}}</span>
                        <span>分</span>
                    </div>
                </div>
            </div>
            <div class="panelBlock">
                <div class="panelTitle">产能评估（一天工作8小时）(占比25%)
                    
                </div>
                <div class="panelContent">
                    <el-row>
                        <el-col :span="6">
                            <span>第一天产能</span>
                            <span class="score">{{gradesObj_prev.model3playerFirstDayNum }}</span>
                            <span>件</span>
                        </el-col>
                        <el-col :span="6">
                            <span>第二天产能</span>
                            <span class="score">{{gradesObj_prev.model3playerSecondDayNum }}</span>
                            <span>件</span>
                        </el-col>
                        <el-col :span="6">
                            <span>第三天产能</span>
                            <span class="score">{{gradesObj_prev.model3playerThirdDayNum }}</span>
                            <span>件</span>
                        </el-col>
                        <el-col :span="6">
                            <span>每200件需要工时</span>
                            <span class="score">{{gradesObj_prev.model3player200needTimeDay}}</span>
                            <span>小时</span>
                        </el-col>
                        
                    </el-row>
                    <div class="smallTitle">
                        专家评委及系统平均值
                    </div>
                    <el-row>
                        <el-col :span="6">
                            <span>第一天产能</span>
                            <span class="score">{{gradesObj_prev.model3expertFirstDayNum }}</span>
                            <span>件</span>
                        </el-col>
                        <el-col :span="6">
                            <span>第二天产能</span>
                            <span class="score">{{gradesObj_prev.model3expertSecondDayNum }}</span>
                            <span>件</span>
                        </el-col>
                        <el-col :span="6">
                            <span>第三天产能</span>
                            <span class="score">{{gradesObj_prev.model3expertThirdDayNum }}</span>
                            <span>件</span>
                        </el-col>
                        <el-col :span="6">
                            <span>每200件需要工时</span>
                            <span class="score">{{gradesObj_prev.model3expert200needTimeDay}}</span>
                            <span>小时</span>
                        </el-col>
                    </el-row>
                    <div class="titleRightSection">
                        <span >考核内容模块三综合得分</span>
                        <span class="score">{{gradesObj_prev.model3totalscore}}</span>
                        <span>分</span>
                    </div>
                </div>
            </div>
            <div class="panelBlock">
                <div class="panelContent">
                    
                </div>
                
                
            </div>
        </div>
        


        <!-- 第三块 -->
        <div class="fengexian">
            决赛成绩
            <div class="totalBox">
                <div class="line">
                    团队总成绩 
                    <span class="score">{{gradesObj_final.totalScore}}</span>分
                
                </div>
                <div  class="line">
                   第<span class="score">{{gradesObj_final.rankingTeam |getInt}}</span>名
                </div>
                <div  class="line">
                    获得奖励：<span class="score">{{gradesObj_final.awarLevel}}</span>

                </div>
                
            </div>
        </div>
        <div class="bigBlockWrap"> 
        <div class="panelBlock">
            <div class="panelTitle">效率分（占比50%）
                该项得分：{{gradesObj_final.efficiencyScore}}分；乘以占比后实际得分:{{gradesObj_final.efficiencyScoreRate}}分
            </div>
            <div class="panelContent">
                 <el-row>
                    <el-col :span="6">
                        <div class="itemBox">
                            <span class="label">难度：</span>
                            <span class="score">{{gradesObj_final.efficiencyDiffculty}}分</span>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="itemBox">
                            <span class="label">件数：</span>
                            <span class="score">{{gradesObj_final.efficiencyOrderNum }}件</span>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="itemBox">
                            <span class="label">合格率：</span>
                            <span class="score">{{gradesObj_final.efficiencyPassRate}}</span>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="itemBox">
                            <span class="label">款号：</span>
                            <span class="score">{{gradesObj_final.efficiencyPrice}}</span>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="itemBox">
                            <span class="label">时间：</span>
                            <span class="score">{{gradesObj_final.efficiencyTime}} 分钟</span>
                        </div>
                    </el-col>
                    
                        
                        
                </el-row>
        
        
            </div>
        </div>
        <div class="panelBlock">
            <div class="panelTitle">质量分（占比50%），该项得分：{{gradesObj_final.qualityAvgScore}}分，乘以占比后实际得分:{{gradesObj_final.qualityAvgScoreRate}}分
                <!-- <span class="score">{{gradesObj_final.qualityAvgScore}}分</span> -->
            </div>
            <div class="panelContent">
                 <el-row>
                    <el-col :span="6">
                        <div class="itemBox">
                            <span class="label">评委一评分：</span>
                            <span class="score">{{gradesObj_final.qualityOneScore}}分</span>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="itemBox">
                            <span class="label">评委二评分：</span>
                            <span class="score">{{gradesObj_final.qualityTwoScore}}分</span>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="itemBox">
                            <span class="label">评委三评分：</span>
                            <span class="score">{{gradesObj_final.qualityThreeScore}}分</span>
                        </div>
                    </el-col>
                    
                        
                        
                </el-row>
        
        
            </div>
        </div>
        </div>
        
    </div>
</template>

<script>
    import {
        json,
        wordData,
        utils
    } from '@/common/common.js'
    import {
        ajaxPost,
        api
    } from '@/common/request.js'
    import QRCode from 'qrcode'

    export default {
        name: 'HelloWorld',
        data() {
            return {
                QRmessage: 'werwer',
                userId: '',
                infoObj: {},
                gradesObj_prev:{},
                gradesObj_final:{},
                isEnterFinal: true,
                tableData: [],
            }
        },
        components: {},
        computed: {

        },
        methods: {
            drawCanvas(){
                let val=this.QRmessage
                var canvas = document.getElementById('canvas')
                
                // 将获取到的数据（val）画到msg（canvas）上
                QRCode.toCanvas(canvas, val, function(error) {
                    console.log(error)
                })
            },
            getParams() {
                this.userId = this.$route.params.userId
            },
            getDetail() {
                let _this = this
                let arg = {
                    userId: _this.userId
                }
                ajaxPost('/yijiajiaUserInfo/getUserInfo', arg).then(function(res) {
                    if (res.errorCode == 200) {
                        _this.infoObj = res.data
                    }
                }, function(res) {

                })
            },
            getGrades() {
                let _this = this
                let arg = {
                    userId: _this.userId
                }
                ajaxPost('/yijiajiaUserInfo/getUserResultInfo', arg).then(function(res) {
                    if (res.errorCode == 200) {
                        _this.gradesObj_prev=res.data.userPreResult?res.data.userPreResult:{}
                        _this.gradesObj_final=res.data.userFinalsResultExcel?res.data.userFinalsResultExcel:{}
                    }
                }, function(res) {
            
                })
            },
            
        },
        created() {

        },
        mounted() {
            this.getParams()
            this.getDetail()
            this.getGrades()
            // this.drawCanvas()
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    // *{outline: 1px solid blue;}
    
    .customerListWrap {
        background: #f7f7f7;
        .score{font-weight: bold;}

        padding-bottom:150px;
        .bigBlockWrap{padding-top:30px;background: #fff;;}
        .smallTitle {
            margin: 10px 0; color:darkblue;
        }

        .totalBox {
            display: inline-block; 
            position: absolute;top:5px;right:10px; color:royalblue;
            .score{font-weight: bold;color:royalblue;font-size: 17px;}
            .line {
                display: inline-block;
                margin-right: 50px;
            }
        }

        .fengexian {
            padding: 10px 0 5px 10px;
            position: relative;  
        }
        .itemBox {
            font-color: #000; padding:3px;
            .label {
                color: #666
            }
        }

        .panelBlock {
            padding:0px 10px;
            border-radius: 4px;
            background: #fff;   
            margin-bottom:10px;
            .panelTitle {
                border-left: 2px solid #3c9fdb;
                padding-left: 20px;
                line-height: 10px;
                color: darkblue; position: relative;
                
            }
            .titleRightSection{
                // position: absolute;top:0;right:50px;
                display: inline-block; font-weight: bold; margin-top:10px; color:#3c9fdb;
            }

            .panelContent {
                padding: 10px 20px;  color: #666

            }
        }

    }
</style>



// WEBPACK FOOTER //
// src/pages/customer/detail.vue